// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_ExcluirResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * PlanoMetas Excluir Response Contract
 *
 * Response for POST /plano_metas/excluir/:id - Delete a goal plan
 *
 * Action endpoint — emits an empty success envelope (no dados payload).
 *
 * @package Contracts
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type PlanoMetas_ExcluirResponseDados = null;

export type PlanoMetas_ExcluirResponse = ApiResponse<PlanoMetas_ExcluirResponseDados>;

registerResponseContract('PlanoMetas_ExcluirResponse', {})
